import React from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'

import i18n from './../../../config/i18n'
import Slider from 'react-slick'
import { createSettings } from './sliderSettings'

import { News } from '../../../entities/News'

import { TopSectionTitle } from '../TopSectionTitle/TopSectionTitle'
import { NewsSectionCard } from './NewsSectionCard/NewsSectionCard'
import { DetailsLink } from '../DetailsLink/DetailsLink'
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary'
import { SectionBlock } from '../SectionBlock/SectionBlock'
import { Hide } from '../Hide'

import './NewsSection.css'

const NewsSection = ({
    title = i18n.t('news-section.title-default'),
    newsList,
    detailsTitle = i18n.t('news-section.details-title-default'),
    link,
    dark = true,
    ...props
}) => {
    const settings = createSettings(newsList)

    const onShowAllNews = () => props.history.push(link)
    const className =
        newsList.length === 1 ? 'one-slide' : newsList.length === 2 ? 'two-slides' : ''

    return (
        <Hide ifEmpty={newsList}>
            <SectionBlock withContainer dark={dark}>
                <div className="news-section">
                    <div className={`news-section--${className}`}>
                        <div className="section-title-centered">
                            <TopSectionTitle title={title} underlined centered dark={!dark} />
                        </div>
                        <ErrorBoundary>
                            <div className="news-section__content">
                                <Slider {...settings}>
                                    {newsList.map((newsItem, index) => (
                                        <NewsSectionCard
                                            newsItem={newsItem}
                                            key={index}
                                            className={className}
                                        />
                                    ))}
                                </Slider>
                            </div>
                        </ErrorBoundary>
                        <DetailsLink
                            text={detailsTitle}
                            onDetailsClick={onShowAllNews}
                            white={dark}
                        />
                    </div>
                </div>
            </SectionBlock>
        </Hide>
    )
}

NewsSection.propTypes = {
    title: PropTypes.string,
    newsList: PropTypes.arrayOf(PropTypes.instanceOf(News)).isRequired,
    detailsTitle: PropTypes.string,
    link: PropTypes.string.isRequired
}

export default withRouter(NewsSection)
